(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-discount-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cart-discount-banner')) {
    customElements.define('cart-discount-banner', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        window.clearInterval(this.interval);
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.sequence = (this.sequence || 0) + 1;
        this.identifier = this.normalize(this.dataset.discountIdentifier);
        this.discountType = this.dataset.discountType;
        this.hidden = true;

        if (this.dataset.enabled !== 'true') return;
        if (this.dataset.editorPreview === 'true') {
          this.hidden = false;
          return;
        }
        if (!this.identifier || !['code', 'automatic'].includes(this.discountType)) return;

        document.addEventListener('discount:update', () => this.refresh(), { signal });
        document.addEventListener('cart:update', () => this.refresh(), { signal });
        window.addEventListener('pageshow', () => this.refresh(), { signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.refresh();
        }, { signal });
        this.interval = window.setInterval(() => {
          if (!document.hidden) this.refresh();
        }, 30000);
        this.refresh();
      }

      disconnectedCallback() {
        this.sequence++;
        this.controller?.abort();
        window.clearInterval(this.interval);
      }

      normalize(value) {
        return String(value ?? '').trim().normalize('NFC').toUpperCase();
      }

      async refresh() {
        const sequence = ++this.sequence;
        const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
        try {
          const response = await fetch(`${root}/cart.js`, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            signal: this.controller.signal,
          });
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          if (this.isConnected && sequence === this.sequence) this.showFor(cart);
        } catch {
          if (this.isConnected && sequence === this.sequence) this.hidden = true;
        }
      }

      matchesAutomatic(application, amount) {
        return application?.type === 'automatic'
          && this.normalize(application.title) === this.identifier
          && Number(amount) > 0;
      }

      showFor(cart) {
        let applicable = false;
        if (this.identifier && Number(cart?.item_count) > 0) {
          if (this.discountType === 'code') {
            applicable = Array.isArray(cart.discount_codes) && cart.discount_codes.some(discount =>
              this.normalize(discount?.code) === this.identifier && discount?.applicable === true
            );
          } else if (this.discountType === 'automatic') {
            const cartDiscounts = Array.isArray(cart.cart_level_discount_applications)
              ? cart.cart_level_discount_applications : [];
            const items = Array.isArray(cart.items) ? cart.items : [];
            applicable = cartDiscounts.some(application =>
              this.matchesAutomatic(application, application?.total_allocated_amount)
            ) || items.some(item =>
              Array.isArray(item?.line_level_discount_allocations)
              && item.line_level_discount_allocations.some(allocation =>
                this.matchesAutomatic(allocation?.discount_application, allocation?.amount)
              )
            );
          }
        }
        this.hidden = !applicable;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-promo-landscape"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cz-promo-landscape')) {
    customElements.define('cz-promo-landscape', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          if (!this.onDocumentReady) {
            this.onDocumentReady = () => {
              this.onDocumentReady = null;
              if (this.isConnected) this.initialize();
            };
            document.addEventListener('DOMContentLoaded', this.onDocumentReady, { once: true });
          }
        } else {
          this.initialize();
        }
      }

      initialize() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.cards = Array.from(this.querySelectorAll('[data-campaign]'));
        this.isEditor = this.dataset.editor === 'true';
        this.forcedBlock = '';
        this.timer = null;
        this.copyTimers = new Set();
        const signal = this.controller.signal;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-copy]');
          if (button && this.contains(button)) this.copyCode(button);
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.refresh();
        }, { signal });
        window.addEventListener('pageshow', () => this.refresh(), { signal });
        if (this.isEditor) {
          document.addEventListener('shopify:block:select', event => {
            const blockId = String(event.detail?.blockId || '');
            if (this.cards.some(card => card.dataset.blockId === blockId)) {
              this.forcedBlock = blockId;
              this.refresh();
            }
          }, { signal });
          document.addEventListener('shopify:block:deselect', event => {
            if (String(event.detail?.blockId || '') === this.forcedBlock) {
              this.forcedBlock = '';
              this.refresh();
            }
          }, { signal });
        }
        this.refresh();
      }

      disconnectedCallback() {
        if (this.onDocumentReady) {
          document.removeEventListener('DOMContentLoaded', this.onDocumentReady);
          this.onDocumentReady = null;
        }
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.timer);
        this.copyTimers?.forEach(clearTimeout);
      }

      parseBoundary(value, fallback) {
        if (!value?.trim()) return fallback;
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(value.trim())) return NaN;
        return Date.parse(value.trim());
      }

      refresh() {
        clearTimeout(this.timer);
        const now = Date.now();
        const schedule = this.dataset.schedule === 'true';
        let nextBoundary = Infinity;
        let active = null;
        this.cards.forEach(card => {
          if (card.dataset.enabled !== 'true') return;
          const start = this.parseBoundary(card.dataset.start, -Infinity);
          const end = this.parseBoundary(card.dataset.end, Infinity);
          if (schedule && (Number.isNaN(start) || Number.isNaN(end) || end <= start)) return;
          if (schedule) {
            if (start > now) nextBoundary = Math.min(nextBoundary, start);
            if (end > now) nextBoundary = Math.min(nextBoundary, end);
          }
          if (!active && (!schedule || (now >= start && now < end))) active = card;
        });
        if (this.isEditor) {
          if (this.forcedBlock) active = this.cards.find(card => card.dataset.blockId === this.forcedBlock) || active;
          else if (this.dataset.preview === 'first') active = this.cards[0] || active;
          else if (this.dataset.preview === 'second') active = this.cards[1] || active;
          active ||= this.cards[0];
        }
        this.cards.forEach(card => { card.hidden = card !== active; });
        this.hidden = !active && !this.isEditor;
        const note = this.querySelector('[data-editor-note]');
        if (note) note.hidden = Boolean(active);
        if (schedule && Number.isFinite(nextBoundary)) {
          this.timer = setTimeout(() => this.refresh(), Math.min(86400000, Math.max(100, nextBoundary - now + 30)));
        }
      }

      async copyCode(button) {
        const card = button.closest('[data-campaign]');
        const input = card.querySelector('[data-code]');
        const status = card.querySelector('[data-status]');
        if (!input?.value) return;
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(input.value);
          if (!this.isConnected) return;
          button.textContent = this.dataset.copiedLabel;
          status.textContent = this.dataset.copiedLabel;
          const timer = setTimeout(() => {
            button.textContent = this.dataset.copyLabel;
            this.copyTimers.delete(timer);
          }, 4000);
          this.copyTimers.add(timer);
        } catch (error) {
          if (!this.isConnected) return;
          input.focus();
          input.select();
          input.setSelectionRange(0, input.value.length);
          status.textContent = this.dataset.copyFallback;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
